import React, { useEffect } from "react";
import { signOut } from "@triare/auth-redux/dist/saga/auth/signOut";
import { Button, Dropdown, MenuProps } from "antd";
import {
  DownOutlined,
  LockOutlined,
  LogoutOutlined,
  UserOutlined,
} from "@ant-design/icons";
import { connect } from "react-redux";
import store, { RootState } from "../../../store";
import { useAuth } from "../../../store/auth";
import { useNavigate } from "react-router";
import styles from "./index.module.scss";

export default function UserMenu(): React.ReactNode | null {
  const { user } = useAuth();
  const navigate = useNavigate();

  const menuItems: MenuProps["items"] = [
    {
      key: "changePassword",
      label: "Change password",
      icon: <LockOutlined />,
      onClick: () => {
        navigate("/change-password");
      },
    },
    {
      key: "logout",
      label: "Log out",
      icon: <LogoutOutlined />,
      onClick: () => {
        store.dispatch(signOut());
        navigate("/", { replace: true });
      },
    },
  ];

  return (
    <Dropdown menu={{ items: menuItems }} placement="bottomRight">
      <Button className={styles.btn} type="text">
        <div className={styles.icon}>
          <UserOutlined style={{ color: "#FFFFFF" }} />
        </div>
        {user?.firstName} {user?.lastName}
        <DownOutlined style={{ color: "#00000073" }} />
      </Button>
    </Dropdown>
  );
}
